import { Typography, Link } from "@material-ui/core";

function OlympiadsOver(props) {
  const { currentStudyYear, nextStudyYear, chatFormOpen } = props;
  return (
    <>
      <Typography align="justify" variant="body1" component="p">
        Регистрация для участия в многопрофильной университетской олимпиаде ГрГУ
        имени Янки Купалы в {currentStudyYear}/{nextStudyYear} учебном году
        завершилась.
      </Typography>
      <Typography align="justify" variant="body1" component="p">
        Информацию о порядке приема в университет в {nextStudyYear} году на иных
        условиях Вы можете получить, обратившись в{" "}
        <Link onClick={chatFormOpen} variant="body1">
          «Чат»
        </Link>{" "}
        Цифрового кабинета абитуриента.
      </Typography>
      <Typography align="justify" variant="body1" component="p">
        Желаем успехов!
      </Typography>
    </>
  );
}

export default OlympiadsOver;
